import { HStack, Badge, BadgeText } from "@gluestack-ui/themed";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";

import { ListOptionsSelectedProps } from "./types";
import { ScrollView } from "@gluestack-ui/themed";

export const ListOptionsSelected = ({
  itemsSelecteds
}: ListOptionsSelectedProps) => {
  const { isWeb } = useDeviceType();

  if (!itemsSelecteds) {
    return null;
  }

  if (isWeb) {
    return (
      <HStack
        rowGap="$2"
        flexWrap="wrap"
        overflow="hidden"
        height="$fit-content"
        mt="$2"
      >
        {itemsSelecteds?.map((item, index) => (
          <Badge
            key={`${item}-${index}`}
            mr="$2"
            variant="outline"
            size="md"
            rounded="$full"
            px="$4"
            py="$1"
            borderColor="$primary600"
            backgroundColor="$white"
          >
            <BadgeText
              textTransform="none"
              color="$primary700"
              fontWeight={600}
              fontSize="$xs"
            >
              {item}
            </BadgeText>
          </Badge>
        ))}
      </HStack>
    );
  }

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      height="$fit-content"
      mt="$2"
    >
      {itemsSelecteds?.map((item, index) => (
        <Badge
          key={`${item}-${index}`}
          mr="$2"
          variant="outline"
          size="md"
          rounded="$full"
          borderColor="$primary600"
          backgroundColor="$white"
          px="$4"
          py="$1"
        >
          <BadgeText textTransform="none" color="$primary700" fontSize="$xs">
            {item}
          </BadgeText>
        </Badge>
      ))}
    </ScrollView>
  );
};
